var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"throbber flex h-full items-center justify-center",class:[_vm.hasSize, _vm.hasColor]},[_c('div',{staticClass:"ball"}),_c('div',{staticClass:"ball"}),_c('div',{staticClass:"ball"})])
}
var staticRenderFns = []

export { render, staticRenderFns }